import apiAsync from 'infrastructure/shared/api/api-async'
import { FilterResponse } from 'shared/types'

export default function postObjectsFilter<ResponseType>(
  obj: unknown,
  showLoading?: boolean
): Promise<FilterResponse<ResponseType>> {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: 'objects/_filter',
    method: 'POST',
    obj: obj,
    showLoading: showLoading
  })
}
